import { getSelectedTableView } from 'owa-mail-list-store';
import type { InboxRuleActionSource } from 'owa-inbox-rules-option';
import { lazyCreateRuleFromRow } from 'owa-mail-inbox-rules';

export default async function onCreateRule(
    actionSource: InboxRuleActionSource,
    targetWindow?: Window
): Promise<void> {
    const tableView = getSelectedTableView();
    const rowKeys = [...tableView.selectedRowKeys.keys()];

    const createRuleFromRow = await lazyCreateRuleFromRow.import();
    createRuleFromRow(rowKeys[0], tableView.id, actionSource, targetWindow);
}
